import PoleItem from '@/utils/pole-item';

//
// TODO
//
export class ItemSelected {
  constructor(pole, from) {
    this.pole = pole;
    this.from = from;
  }

  static pole(pole, opts) {
    return pole
        ? new ItemSelected(pole, opts?.from)
        : null;
  }
}

export default ItemSelected;
